import { Api } from '../api';
import { crypto } from '../endpoints';
import type { ApiResponse } from '../../models';
import type { GetWalletAddressesResponse } from './models';

export class CryptoApi extends Api {
  static getWalletAddresses = (accountId: number, signal?: AbortSignal) =>
    this.get<ApiResponse<GetWalletAddressesResponse[]>>({ url: crypto.getWalletAddresses(accountId), signal });
}
